import { getUrlSearchValue, getDecodeValue } from '@/utils'
import request, { API_COURSE_SERVER, ADDRESS_TO_B_URL } from './axios'
export interface AddressInfo {
  area: string;
  default: boolean;
  address: string;
  province: string;
  city: string;
  mobile: string;
  name: string;
  id: number | string;
  time: number;
}

/**
    * -------------------------------------------------------
    * 地址相关
    */

// 获取用户地址 没有id返回默认地址
export const getAllAddress = () => {

  const { studentId  } = getUrlSearchValue()

  if(studentId) {
    return request(
      `${ADDRESS_TO_B_URL}/course-selection/tob/address/list`,
      {
        params: {
          key: 'mhd',
          userId: studentId
        }
      }
    ) as Promise<{ result: AddressInfo[] }>;
  }

  return request(
    `${API_COURSE_SERVER}user/address/getUserAllAddress.json`
  ) as Promise<{ result: AddressInfo[] }>;
}

// addressInfo: {"id":"","name":"123","mobile":"17695796036","province":"河北省",
// "city":"唐山市","area":"路北区","address":"123123","default":true}
// 增加地址
export const addAddress = (addressInfo: Omit<AddressInfo, 'time'>) => {

  const { studentId, ccId  } = getUrlSearchValue()

  if(studentId) {
    return request(
      `${ADDRESS_TO_B_URL}/course-selection/tob/address/add`,
      {
        method: 'POST',
        params: {
          key: 'mhd',
          userId: studentId,
          coachUserId: getDecodeValue(ccId)
        },
        data: {
          addressInfo
        }
      }
    ) as Promise<{ success: boolean }>;
  }

  return request(`${API_COURSE_SERVER}user/address/addUserAddress.json`, {
    params: {
      addressInfo: JSON.stringify(addressInfo),
    }
  }) as Promise<{ success: boolean }>;
}
// 删除地址
export const deleteUserAddress = (addressId: number) => {
  const { studentId  } = getUrlSearchValue()

  if(studentId) {
    return Promise.reject('')
  }

  return request(`${API_COURSE_SERVER}user/address/deleteUserAddress.json`, {
    params: {
      addressId,
    }
  }) as Promise<{ success: boolean }>;
}
// 更新地址
export const updateUserAddress = (addressInfo: Omit<AddressInfo, 'time'>) => {

  const { studentId, ccId  } = getUrlSearchValue()

  if(studentId) {
    return request(
      `${ADDRESS_TO_B_URL}/course-selection/tob/address/update`,
      {
        method: 'POST',
        params: {
          key: 'mhd',
          userId: studentId,
          coachUserId: getDecodeValue(ccId)
        },
        data: {
          addressInfo
        }
      }
    ) as Promise<{ success: boolean }>;
  }

  return request(`${API_COURSE_SERVER}user/address/updateUserAddress.json`, {
    params: {
      addressInfo: JSON.stringify(addressInfo),
    }
  }) as Promise<{ success: boolean }>;
}
